// extracted by css-extract-rspack-plugin
export default {"Button":"index-module__Button__rr1MO","Box":"index-module__Box__z5tjm","NavList":"index-module__NavList__Lhc6c"};